import classNames from "classnames";
import React from "react";
import Logo from "../../../assets/images/svgs/Bria-logo.svg";
import WhiteLogo from "../../../assets/images/svgs/Bria-white-logo.svg";
import { ThemeMode } from "../../../constants/themes.ts";
import { useTheme } from "../../../context/ThemeContext.tsx";

type LogoComponentProps = {
	onLogoClick?: () => void;
	type?: ThemeMode;
	customLogo?: string;
	className?: string;
	altText?: string;
};

const BriaLogo: React.FC<LogoComponentProps> = React.memo(
	({ onLogoClick, type, customLogo, className, altText = "Bria Logo" }) => {
		const { mode } = useTheme();
		const localType = type || mode;

		// Select appropriate logo based on theme or custom logo
		const logoSrc =
			customLogo || (localType === ThemeMode.Dark || localType === ("labs" as ThemeMode) ? WhiteLogo : Logo);

		return (
			<img
				src={logoSrc}
				alt={altText}
				aria-label={altText}
				onClick={onLogoClick}
				style={{ cursor: "pointer" }}
				className={classNames("bria-logo", className)}
			/>
		);
	},
);

export default BriaLogo;
